import React, { ReactElement, useContext, useState } from 'react';
import SelectLocationStripe from './SelectionLocationStripe';
import LocationDrawer from './LocationDrawer';
import { Location } from 'types/common';
import { ScrollContext } from 'context/ScrollContext';

interface InventoryByLocationProps {
  locations: Location[];
  selectedLocation: Location | null;
  setSlectedLocation: (location: Location) => void;
  locationToogle: boolean;
  setLocationToggle: (locationToggle: boolean) => void;
  filterHeight: number;
  isLocationTooltipOpen: boolean;
  setLocationTooltipOpen: (isLocationTooltipOpen: boolean) => void;
}

const InventoryByLocation = ({
  locations,
  selectedLocation,
  setSlectedLocation,
  locationToogle,
  setLocationToggle,
  filterHeight,
  isLocationTooltipOpen,
  setLocationTooltipOpen,
}: InventoryByLocationProps): ReactElement => {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const { navShowing, stickyFilters, headerHeight, isMobile } = useContext(ScrollContext);

  const toggleDrawer = (open: boolean): void => {
    setOpenDrawer(open);
  };

  const onBrowseLocation = (location: Location): void => {
    setSlectedLocation(location);
    setOpenDrawer(false);
  };

  const getHeight = (): number => {
    if (stickyFilters && !navShowing) return filterHeight;
    else if (stickyFilters && navShowing) return headerHeight + filterHeight;
    return 0;
  };
  return (
    <div>
      <div
        style={{
          top: getHeight(),
        }}
        className={`${stickyFilters ? `fixed inset-x-0 z-30` : ''}`}
      >
        <SelectLocationStripe
          toggleDrawer={toggleDrawer}
          selectedLocation={selectedLocation}
          locationToogle={locationToogle}
          setLocationToggle={setLocationToggle}
          stickyFilters={stickyFilters}
          isLocationTooltipOpen={isLocationTooltipOpen}
          setLocationTooltipOpen={setLocationTooltipOpen}
          isMobile={isMobile}
        />
      </div>
      <LocationDrawer
        openDrawer={openDrawer}
        toggleDrawer={toggleDrawer}
        locations={locations}
        onBrowseLocation={onBrowseLocation}
      />
    </div>
  );
};

export default InventoryByLocation;
